import type { PropsWithChildren, ReactElement, ReactNode } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import LeadScoreTooltipCloseButton from "../LeadScoreTooltipCloseButton/LeadScoreTooltipCloseButton";
import type { ILeadScoreTooltipFooterProps } from "../LeadScoreTooltipFooter/LeadScoreTooltipFooter";
import LeadScoreTooltipLayout from "../LeadScoreTooltipLayout/LeadScoreTooltipLayout";
import LeadScoreTooltipStatusHeader from "../LeadScoreTooltipStatusHeader/LeadScoreTooltipStatusHeader";

interface IProps extends ILeadScoreTooltipFooterProps {
    pager: ReactNode;
    onClose: VoidFunction;
}

const LeadScorePagedTooltipView = ({
    score,
    pager,
    onClose,
    children,
    ...footerProps
}: PropsWithChildren<IProps>): ReactElement => {
    const header = (
        <>
            <Flex
                justifyContent="space-between"
                alignItems="center"
            >
                <Flex flex="1" />
                {pager}
                <Flex
                    flex="1"
                    justifyContent="flex-end"
                >
                    <LeadScoreTooltipCloseButton onClose={onClose} />
                </Flex>
            </Flex>

            <LeadScoreTooltipStatusHeader score={score} />
        </>
    );

    return (
        <LeadScoreTooltipLayout
            {...footerProps}
            score={score}
            header={header}
        >
            {children}
        </LeadScoreTooltipLayout>
    );
};

export default LeadScorePagedTooltipView;
